import { TABLET_API_ORIGIN } from '@/global/env';
import { RestClientInterface } from '@/lib/restClient';
import {
  SearchItem,
  SearchItemParams,
} from '@/pages/menu-managements/services/searchItem';
import { MenuManagementBrandOptionGroupCreateParams } from '@/services/BrandOptionGroup/hooks/create/useMenuManagementCreateBrandOptionGroup';
import {
  BrandOptionGroupListResponse,
  MenuManagementBrandOptionGroupListParams,
} from '@/services/BrandOptionGroup/hooks/list/useMenuManagementBrandOptionGroupList';
import { menuManagementListQueryParams } from '@/services/Service/MenuManagementList';

import { ShowBrandOptionGroupResponse } from './hooks/show/useMenuManagementBrandOptionGroupShow';
import { MenuManagementBrandOptionGroupUpdateParams } from './hooks/update/useMenuManagementUpdateBrandOptionGroup';

interface Interface {
  search: (params: SearchItemParams) => Promise<SearchItem[]>;
  create: (params: MenuManagementBrandOptionGroupCreateParams) => Promise<void>;
  list: (
    params: MenuManagementBrandOptionGroupListParams
  ) => Promise<BrandOptionGroupListResponse>;
  update: (
    id: string,
    params: MenuManagementBrandOptionGroupUpdateParams
  ) => Promise<void>;
  delete: (id: string) => Promise<void>;
}

export class MenuManagementBrandOptionGroupService implements Interface {
  constructor(private readonly restClient: RestClientInterface) {}

  public async search(params: SearchItemParams): Promise<SearchItem[]> {
    const query =
      `?associate_brand_id=${params.associate_brand_id.toString()}&title=${
        params.title
      }` as const;
    return await this.restClient.get(
      `${TABLET_API_ORIGIN}/dashboard-api/brand-option-groups/search${query}` as const
    );
  }

  public async create(
    params: MenuManagementBrandOptionGroupCreateParams
  ): Promise<void> {
    await this.restClient.post<
      MenuManagementBrandOptionGroupCreateParams,
      void
    >(
      `${TABLET_API_ORIGIN}/dashboard-api/brand-option-groups` as const,
      params
    );
  }

  public async update(
    id: string,
    params: MenuManagementBrandOptionGroupUpdateParams
  ): Promise<void> {
    await this.restClient.patch<
      MenuManagementBrandOptionGroupUpdateParams,
      void
    >(
      `${TABLET_API_ORIGIN}/dashboard-api/brand-option-groups/${id}` as const,
      params
    );
  }

  public async delete(id: string): Promise<void> {
    return await this.restClient.delete(
      `${TABLET_API_ORIGIN}/dashboard-api/brand-option-groups/${id}` as const
    );
  }

  public async show(id: string): Promise<ShowBrandOptionGroupResponse> {
    return await this.restClient.get(
      `${TABLET_API_ORIGIN}/dashboard-api/brand-option-groups/${id}` as const
    );
  }

  public async list(
    params: MenuManagementBrandOptionGroupListParams
  ): Promise<BrandOptionGroupListResponse> {
    const query = menuManagementListQueryParams(params);
    return await this.restClient.get<BrandOptionGroupListResponse>(
      `${TABLET_API_ORIGIN}/dashboard-api/brand-option-groups${query}` as const
    );
  }
}
